import { render } from "./NewsRoomDetailsContent.vue?vue&type=template&id=84263a32"
import script from "./NewsRoomDetailsContent.vue?vue&type=script&lang=js"
export * from "./NewsRoomDetailsContent.vue?vue&type=script&lang=js"

import "./NewsRoomDetailsContent.vue?vue&type=style&index=0&id=84263a32&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__